import React from 'react';
import styles from './MapReport.module.css';
import classnames from 'classnames';
import { GoogleMap } from '../GoogleMap/GoogleMap';
import { VisitModel } from '@mm/state/controllers/VisitsController';
import moment from 'moment';
import { IncognitoIcon } from '@mm/icons';

export const MapReport = ({
  visit,
  mode = 'vertical',
  reportNumber,
  isMobile,
}: {
  visit: VisitModel;
  mode: 'vertical' | 'horizontal';
  reportNumber?: number;
  isMobile: boolean;
}) => {
  if (!visit) {
    return null;
  }

  const ipLocation = `${visit.ipLocation.city.name}, ${visit.ipLocation.country.name}`;

  const position = {
    lat: visit.ipLocation.latitude,
    lng: visit.ipLocation.longitude,
  };

  const formattedTime = (time: string) =>
    moment(time).format('HH:mm:ss MMMM DD, YYYY');

  if (mode === 'vertical') {
    return (
      <div
        className={classnames(
          styles.wrapper,
          styles.wrapper_vertical,
          visit.incognito && styles.wrapper_incognito,
        )}
      >
        <GoogleMap
          width={isMobile ? 'full' : 572}
          height={184}
          position={position}
        />
        <div className={styles.report_wrapper}>
          <div className={styles.report}>
            <div className={styles.report_list}>
              {mode === 'vertical' && (
                <h2 className={styles.report_list__title_vertical}>
                  Your current website visitor report
                </h2>
              )}
              <p className={styles.report_list__item}>
                IP location:{' '}
                <span className={styles.report_list__item_bold}>
                  {visit.ipLocation.city.name}, {visit.ipLocation.country.name}
                </span>
              </p>
              <p className={styles.report_list__item}>
                IP address:{' '}
                <span className={styles.report_list__item_bold}>
                  {visit.ipAddress}
                </span>
              </p>
              <p className={styles.report_list__item}>
                First Visit:{' '}
                <span className={styles.report_list__item_bold}>
                  {formattedTime(visit.firstVisitAt)}
                </span>
              </p>
            </div>
            <div
              className={classnames(
                styles.incognito,
                visit.incognito && styles.incognito_enabled,
              )}
            >
              <IncognitoIcon />
              <span className={styles.incognito_text}>Incognito Mode</span>
              <div className={styles.incognito_toggle}>
                {visit.incognito ? 'Yes' : 'No'}
              </div>
            </div>
          </div>
          <div className={styles.report_note}>
            ☝️
            <p className={styles.report_note_text}>
              <span>Try</span>
              <a href="#a" className={styles.report_note_link}>
                come back in incognito
              </a>
              🕵️
              <span> or</span>
              <a href="#a" className={styles.report_note_link}>
                refresh this page
              </a>
              <span>after deleting cookies 🍪</span>
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div
      className={classnames(
        styles.wrapper,
        styles.wrapper_horizontal,
        visit.incognito && styles.wrapper_incognito,
      )}
    >
      <GoogleMap
        width={isMobile ? 'full' : 247}
        height={229}
        position={position}
      />
      <div className={styles.report_wrapper}>
        <div className={styles.report}>
          <div className={styles.report_list}>
            {reportNumber && (
              <h2 className={styles.report_list__title_horizontal}>
                <span className={styles.report_number}>#{reportNumber}</span>
              </h2>
            )}
            <p className={styles.report_list__item}>
              Visit Time:{' '}
              <span className={styles.report_list__item_bold}>
                {formattedTime(visit.visitedAt)}
              </span>
            </p>
            <p className={styles.report_list__item}>
              IP location:{' '}
              <span className={styles.report_list__item_bold}>
                {ipLocation}
              </span>
            </p>
            <p className={styles.report_list__item}>
              IP address:{' '}
              <span className={styles.report_list__item_bold}>
                {visit.ipAddress}
              </span>
            </p>
          </div>
          <div
            className={classnames(
              styles.incognito,
              visit.incognito && styles.incognito_enabled,
            )}
          >
            <IncognitoIcon />
            <span className={styles.incognito_text}>Incognito Mode</span>
            <div className={styles.incognito_toggle}>
              {visit.incognito ? 'Yes' : 'No'}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
